export const worldPl = {
  'world.seo.title': 'Świat',
  'world.seo.description':
    'Odkryj interaktywne mapy Grymwyrd — jej królestwa, ruiny i legendarne miejsca w kartografii 2D i obracającym się globie 3D.',
  'world.heading': 'Świat',
  'world.intro':
    'Kartuj wieczny zmierzch. Atlas zbudowany do zagnieżdżonego ujęcia — przybliżaj się od całego świata do pojedynczego lochów. Na razie interaktywna jest tylko najwyższa warstwa; głębsze warstwy będą otwierane wraz z mapowaniem Królestwa.',

  'world.viewMode.label': 'Tryb widoku mapy',
  'world.viewMode.map2d': 'Mapa 2D',
  'world.viewMode.globe3d': 'Glob 3D',

  'world.gazetteer.navLabel': 'Lokacje i miejsca',
  'world.gazetteer.heading': 'Gazeta',
  'world.gazetteer.sampleNotice':
    'Pokazane są przykładowe lokacje — pełny spis kartografa nie został jeszcze sporządzony.',
  'world.gazetteer.error': 'Nie można dotrzeć do archiwum atlasu.',

  'world.loading.atlas': 'Rozwijanie atlasu…',
  'world.loading.globe': 'Obracanie świata…',

  'world.layersActive': 'Aktywne warstwy: {active} z {total}.',
  'world.globeHint':
    'Przeciągnij aby obracać (autoobracanie pauzuje podczas eksploracji, wznawiane po minucie bezczynności); przewiń aby przybliżyć. Najedź na heks, aby odkryć jego kampanię, kliknij, aby wejść.',
  'world.webglUnavailable':
    'Glob 3D wymaga WebGL, które tutaj nie jest dostępne — wyświetlam zamiast tego atlas 2D.',

  'world.campaign.capitalRegion': 'Region Stolicy',
  'world.campaign.territory': 'Terytorium Kampanii',
  'world.campaign.enter': 'Wejdź do Kampanii',
  'world.campaign.stay': 'Pozostań na Orbicie',

  'world.layers.heading': 'Warstwy Mapy',
  'world.layers.gmBadge': 'MG',
  'world.layers.gmRequired': 'Wymaga roli Mistrza Gry.',

  'world.marker.sampleBadge': 'Dane przykładowe',
  'world.marker.viewInEncyclopedia': 'Wyświetl w Encyklopedii',
  'world.marker.placeholderNote':
    'To jest miejsce zastępcze — kiedy zostanie napisana jego legenda, połączy się z Encyklopedią.',

  'world.map2d.ariaLabel': 'Interaktywna mapa świata',
  'world.map2d.noOverworld': 'Kartografia świata nie została jeszcze wygrawerowana — wyświetlam pustkę',

  'world.globe.hint.enter': 'Wejdź ▸',
  'world.globe.hint.open': 'Otwórz ▸',
  'world.globe.hint.claim': 'Zajmij ▸',
  'world.globe.uncharted': 'Niezbadane Krańce',
  'world.globe.unchartedBlurb':
    'Żadna kampania nie zajęła tego heksu wiecznego zmierzchu. Postaw pierwszy sztandar.',
  'world.globe.capitalLabel': 'Grymwyrd',
} as const
